import { useState } from 'react'

import { useDate } from '../../../hooks'
import { MonthInput } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { controls, dateTime, numberSize } from '../Controls'

import { DateTimeProviderProps } from './DateTimeProviderProps'

export function MonthInputUsage() {
  const current = useDate(Infinity)

  const [props, setProps] = useState(() =>
    controls() //
      .add(dateTime('maxValue', null))
      .add(dateTime('minValue', null))
      .add(numberSize('size'))
      .add(dateTime('value', current))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <DateTimeProviderProps>
      <Component
        {...props.getValues()}
        Component={MonthInput}
        name='MonthInput'
        onChange={handleChange}
      />
      <ComponentProps name='MonthInput' value={props} onChange={setProps} />
    </DateTimeProviderProps>
  )
}
